<div id="settings-case-number-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH CLIENT / DEPARTMENTS OR OFFICES -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <mat-form-field class="full-width">
                        <mat-label>{{ 'case_number_management.label.case_number_defined_per' | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}input_select.base_level"
                                    [(ngModel)]="selectedLevel"
                                    [disabled]="disabled">
                            <mat-option *ngFor="let level of availableStructureLevels"
                                        id="{{idPrefix}}input_select.base_level.option_{{level.key}}"
                                        [value]="level">
                                {{ level.trans | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <action-list [items]="selectedLevelStructureList"
                                 [selected]="selected"
                                 [idPrefix]="idPrefix"
                                 [identifier]="'reference_id'"
                                 (select)="select($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED OFFICE / DEPARTMENT / CLIENT  -->

        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>

                    <div class="smp-title mb-3" *ngIf="selected">{{ selectedLevel.trans | translate | uppercase }}: {{ selected.reference_name | uppercase }}</div>

                    <case-number-structure *ngIf="selected"
                                           [bananaBox]="selected"
                                           [availableFields]="caseNumberStructureSettings.available_fields"
                                           [idPrefix]="idPrefix"
                                           (bananaBoxChange)="save($event)"
                                           (canceled)="cancel()">
                    </case-number-structure>

                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>
